import styled from 'styled-components'

export const Container = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 9004;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    min-width: 360px;
    max-height: 90vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center; 
    padding: 0 1.5vw;    
`

export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;        
    max-width: 31vw;    
    margin-top: 2.8vh;
    margin-bottom: 1vh;
`

export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;
    transition: background 0.2s;

    &:hover {
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const OptionTabDiv = styled.div`
    display: flex;
    align-items: center; 
    justify-content: space-between;
    width: 100%;
    max-width: 30.4vw;
    min-height: 12vh; 
    margin-top: 1.5vh;
    padding: 1vh 1.2vw; 
    border: 1px #EBEBEB solid;
    border-radius: 1vw;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    position: relative;
    overflow: hidden;

    &:hover {
        background-color: #E6F4FB;
        border-color: #0090D3;
    }
`

export const OptionImg = styled.img`
    width: 1.6vw;
    flex-shrink: 0;
    transition: filter 0.2s;

    
`

export const OptionTextDiv = styled.div`
    margin-left: 1.2vw;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center; // Centraliza os textos verticalmente
    height: 100%;
    min-height: inherit; // Força o alinhamento central baseado no pai
`

export const OptionMainText = styled.h3`
    font-family: 'Inter', sans-serif;
    font-size: 1.1vw;
    font-weight: 700;
    line-height: 1.2;
    margin: 0;
    transition: color 0.2s;

    
`

export const OptionSubText = styled.p`
    font-family: 'Inter', sans-serif;
    font-size: 0.9vw;
    color: #666;
    margin-top: 0.4vh;
    margin-bottom: 0;
    line-height: 1.3;
`

export const ArrowImg = styled.img`
    width: 1.2vw;
    margin-left: 1vw;
    opacity: 0.6;
    transition: transform 0.2s, opacity 0.2s;
    flex-shrink: 0; // Impede que a seta amasse

    
`

export const CancelButton = styled.button`
  align-self: flex-end;
  /* Largura e altura consistentes */
  min-width: 8vw; 
  height: 5.8vh; 
  
  /* Margens para desgrudar das bordas e das opções */
  margin: 30px 10px 20px 0; 
  
  background-color: #fff;
  color: #0090D3;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 700;
  border: 1px #0090D3 solid;
  border-radius: 30px;
  cursor: pointer;
  
  /* Garante que o texto fique centralizado e o botão não "suma" */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; 

  transition: all 0.2s;

  &:hover {
    background-color: #f0f9ff;
  }
`